// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_VVi","cls2":"RelatedWorksCard-cls2_3P7 RelatedWorksCard-cls1_VVi"};